import { createTextNode, createDivElement } from './utils';

import { clsSectionHeaderOld } from '../components/styles';

/** @brief Simple function to create Accordion header
 * @param    {HTMLElement} parent Element to append newly created element to.
 * @param    {string} [title] a title of the accordion
 * @param    {boolean} [bCollapsed] if header is collapsed
 * @param    {string} [clsAdd] additional Element's className attribute.
 * @returns  {HTMLElement}
 */
export function createAccordionHeader(parent:HTMLElement, title:string, bCollapsed:boolean=false, bLowPriority: boolean=false, clsAdd:string = ""):HTMLElement|null {
    let divTitle=null;
    if (title) { //??
        let cls = !bLowPriority ? clsSectionHeaderOld : "accordion-header ios-clickable accordion-low-priority no-select";
        if (!bCollapsed) cls += ' active'
        if (clsAdd) cls += ' '+clsAdd;
        divTitle = createDivElement(parent, cls);
        divTitle.onclick = accordionToggle;
        createTextNode(divTitle, title);
    }
    return divTitle; // could be undefined!
}

/** @brief Simple function to create Accordion content
 * @param    {HTMLElement} parent Element to append newly created element to.
 * @param    {boolean} [bCollapsed] if content is collapsed
 * @param    {string} [clsAdd] additional Element's className attribute.
 * @returns  {HTMLElement}
 */
 export function createAccordionContent(parent:HTMLElement, bCollapsed:boolean=false, clsAdd:string=""):HTMLElement {
    let cls = 'accordion-content';
    if (bCollapsed) cls += ' collapsed'
    if (clsAdd) cls += ' ' + clsAdd;
    return createDivElement(parent, cls);
}

/** @brief Simple function to create Accordion
 * @param    {HTMLElement} parent Element to append newly created element to.
 * @param    {string} [title] title
 * @param    {boolean} [bCollapsed] if content is collapsed
 * @param    {string} [clsAddTitle] additional Title's className attribute.
 * @param    {string} [clsAddContent] additional Content's className attribute.
 * @returns  {HTMLElement}
 */
 export function createAccordion(parent:HTMLElement, title:string, bCollapsed:boolean=false, bLowPriority: boolean=false, clsAddTitle:string="", clsAddContent:string=""):HTMLElement {
    createAccordionHeader(parent, title, bCollapsed, bLowPriority, clsAddTitle)
    return createAccordionContent(parent, bCollapsed, clsAddContent);
}

export function accordionToggle(ev:Event, force_show?:boolean): void {
    const header = ev.currentTarget || ev.target;
    accordionToggleByHeader(header as HTMLElement, force_show);
}

export function accordionToggleByHeader(header:HTMLElement, force_show:boolean): void {
    const content = header.nextElementSibling;

    if (content && content.classList.contains('accordion-content')) {
        header.classList.toggle("active", force_show);
        const accordion_arrow = header.querySelector(".accordion_arrow");
        if (accordion_arrow) {
            const accordion_label = header.querySelector(".accordion_label");
            accordion_arrow.classList.toggle("active", force_show);
            accordion_label.classList.toggle("active", force_show);
        }
        content.classList.toggle("collapsed", force_show === undefined? undefined : !force_show);
    }
}

export function accordionOpen(ev:Event) : void {
    accordionToggle(ev, true);
}

